export class OpportunityServiceView {
  createdDate!: string;
  engagementId!: string;
  modifiedDate!: string;
  operationUnit!: OperationUnitView;
  status!: number;
  ordinal!: number;
  serviceOfferingId!: string;
  id!: string;
  serviceAmount!: any;
  serviceBaseCurrencyAmount!: string;
  revenueScheduleTotalAmount!: any;
}

export class OperationUnitView {
  Code!: string;
  PurposeCode!: string;
  SolutionSegments!: SolutionSegmentView[];
  id?: string;
  name?: string;
  isDeleted?: string;
}

export class SolutionSegmentView {
  Code!: string;
  OperationUnitId!: string;
  ServiceOfferings!: ServiceOfferingView[];
}

export class ServiceOfferingView {
  Code!: string;
  SolutionSegmentId!: string;
  id?: string;
}
